module.exports = __webpack_public_path__ + "img/1f52c.7c7a7fc.svg";